import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import Http from '@shared/http'
import routes from '@utils/routes'

export const TimeValue = {
  present: 'present',
  future: 'future'
}

export const TimeValuePropType = PropTypes.oneOf(Object.values(TimeValue))

export default function useTimeValue({
  tenantSlug,
  clientId,
  defaultValue = TimeValue.present
}) {
  const [timeValue, setTimeValue] = useState(defaultValue)
  const toggleTimeValue = () => {
    if (timeValue === TimeValue.present) {
      setTimeValue(TimeValue.future)
    } else {
      setTimeValue(TimeValue.present)
    }
  }
  const usePresentValue = timeValue === TimeValue.present
  const useFutureValue = timeValue === TimeValue.future
  useEffect(() => {
    Http.request(
      routes.setSessionTimeValuePath({ tenantSlug, clientId, timeValue }), 'PUT')
  }, [timeValue])

  return {
    timeValue,
    toggleTimeValue,
    setTimeValue,

    // Convenience flags
    usePresentValue,
    useFutureValue
  }
}

